"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _UserAvatar = _interopRequireDefault(require("../../User/UserAvatar"));

var _dateRelative = _interopRequireDefault(require("../../../libs/translationsUtils/dateRelative"));

var _classnames = _interopRequireDefault(require("classnames"));

var FeaturedBanner = function FeaturedBanner(_ref) {
  var data = _ref.data;
  var topic = data[0];
  var author = topic.author;
  return (0, _preact.h)("a", {
    className: (0, _classnames.default)('box', 'banner-notification', 'notification'),
    href: (0, _absoluteUrlRuntime.resolveUrl)(topic.url)
  }, (0, _preact.h)("div", {
    className: "box__content box__pad"
  }, (0, _preact.h)("p", {
    className: "notification-title"
  }, (0, _preact.h)("span", {
    className: "notification-link"
  }, topic.title.length > 100 ? topic.title.substring(0, 100) + '...' : topic.title)), (0, _preact.h)("span", {
    className: "thread-meta-item"
  }, (0, _preact.h)(_UserAvatar.default, {
    user: author,
    extraClass: "avatar avatar--S",
    showRank: true
  }), (0, _preact.h)("span", {
    className: "notification-link"
  }, (0, _preact.h)("span", {
    className: "thread-meta-item__date"
  }, (0, _preact.h)(_dateRelative.default, {
    dateTime: new Date(topic.publishedAt).getTime()
  }))))));
};

var _default = FeaturedBanner;
exports.default = _default;